import type { HandoverItineraryOption } from "../types";

export { calculateRosterReceivableSummary } from "./rosterReceivableSummary";

export {
  collectSalesHandoverRequiredErrors,
} from "./salesHandoverRequired";
export type {
  SalesHandoverRequiredError,
  SalesHandoverRequiredFieldKey,
} from "./salesHandoverRequired";

export {
  buildGuideContractSigningPlan,
  groupActiveGuideLines,
} from "./groupGuideLines";
export type {
  GuideContractSigningPlan,
  GuideContractSigningPlanResult,
  OrderHandoverGuideGroup,
} from "./groupGuideLines";

/** 计算行程对应的合同交接人数标签。 */
export function formatItineraryPeople(option: HandoverItineraryOption): string {
  const total = option.studentCount + option.teacherCount + option.guideCount;
  const parts = [`学生${option.studentCount}`, `老师${option.teacherCount}`];
  if (option.guideCount > 0) {
    parts.push(`导游${option.guideCount}`);
  }
  return `${total}人（${parts.join("+")}）`;
}
